import {Template} from "../../../../../components/template/template.jsx";
import React from "react";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import AbsenceTypeService from "../../../../../services/web/absence-type-service.js";
import InputFile from "../../../../../components/input/input-file.jsx";
import {FaPlus} from "react-icons/fa";
import {initialForm} from "./absence-form-utils.js";
import {useAbsenceForm} from "./use-absence-form.js";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import PeriodInput from "../../../../../components/input/period-input.jsx";
const AbsenceForm = () => {
    const {
        id, form, setForm, userInput,usersSummary, absenceTypes,
        isLoading, navigate, handleSelectChange, handleSave, destroy
    } = useAbsenceForm();

    const openForm = () => {
        const urlDev = `/absences/form/`;
        setForm(initialForm)
        navigate(urlDev);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Ausência
                </Template.Title>
                { !!id &&
                    <Button target="primary-outline" onClick={openForm}>
                        <FaPlus/><span className="font-bold">Adicionar ausência</span>
                    </Button>
                }
            </Template.Header>
            <Template.Body className="flex flex-col gap-2">
                <Card>
                    <Card.Body>
                        <div className="w-full grid grid-cols-12 gap-4">
                            <div className="col-span-3">
                                <SelectComponent
                                    id="agent"
                                    value={usersSummary.names.find(s => s.value === form?.user_id)}
                                    options={usersSummary.names}
                                    label={"Nome *"}
                                    isDisabled={userInput === "namewar"}
                                    onChange={(selected) => handleSelectChange(selected, "name")}
                                />
                            </div>

                            <div className="col-span-3">
                                <SelectComponent
                                    id="agentWarName"
                                    value={usersSummary.warNames.find(s => s.value === form?.user_id)}
                                    options={usersSummary.warNames}
                                    label={"Nome de guerra *"}
                                    isDisabled={userInput === "name"}
                                    onChange={(selected) => handleSelectChange(selected, "namewar")}
                                />
                            </div>

                            <div className="col-span-2">
                                <SelectComponent
                                    id="reason"
                                    value={absenceTypes.find(s => s.value === form.type_id)}
                                    options={absenceTypes}
                                    label={"Motivo *"}
                                    onChange={(selected) => setForm(prevState => ({...prevState, type_id: selected?.value ?? ""}))}
                                />
                            </div>

                            <PeriodInput
                                startDateId={'start_date'}
                                endDateId={'end_date'}
                                startDate={form.start_date}
                                endDate={form.end_date}
                                setFilter={setForm}
                                cols={3}
                                label="Data inicial"
                                endLabel="Data final"
                                required
                            />

                            <div className="col-span-1">
                                <InputFile file={form.attach}
                                           setFile={(file) => setForm(prevState => ({...prevState, attach: file}))}
                                           removeFile={() => setForm(prevState => ({...prevState, attach: null, attach_id: null}))}/>
                            </div>

                            <div className="col-span-12 gap-4 mb-3">
                                <InputTextarea
                                    id="observation"
                                    value={form.observation}
                                    label="Observação"
                                    onChange={({target: {value}}) => setForm(prevState => ({...prevState, observation: value}))}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body>
                        <div className="flex flex-row justify-end gap-2">
                            {   !!id &&
                                <Button target="danger" onClick={destroy} actionFeedbackType='delete'>Excluir</Button>
                            }
                            <Button onClick={handleSave} actionFeedbackType='save'>Salvar</Button>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}

export default AbsenceForm